import _classCallCheck from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Smartinspect\\react\\smartinspection.ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var CircleDrawer = /*#__PURE__*/function () {
  function CircleDrawer() {
    _classCallCheck(this, CircleDrawer);
  }
  _createClass(CircleDrawer, [{
    key: "draw",
    value: function draw(context, particle, radius) {
      if (!particle.circleRange) {
        particle.circleRange = {
          min: 0,
          max: Math.PI * 2
        };
      }
      var circleRange = particle.circleRange;
      context.arc(0, 0, radius, circleRange.min, circleRange.max, false);
    }
  }, {
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "particleInit",
    value: function particleInit(container, particle) {
      var _a;
      var shapeData = particle.shapeData,
        angle = (_a = shapeData === null || shapeData === void 0 ? void 0 : shapeData.angle) !== null && _a !== void 0 ? _a : {
          max: 360,
          min: 0
        };
      particle.circleRange = typeof angle !== "object" ? {
        min: 0,
        max: angle * Math.PI / 180
      } : {
        min: angle.min * Math.PI / 180,
        max: angle.max * Math.PI / 180
      };
    }
  }]);
  return CircleDrawer;
}();